import { useLayoutEffect } from 'react';

export function usePreventTouchScroll(isActive: boolean) {
    useLayoutEffect(() => {
        if (!isActive) {
            return;
        }

        const preventScroll = (event: TouchEvent) => {
            // Some browsers mark touchmove as non-cancelable after scrolling
            // has already started; guarding avoids noisy console warnings.
            if (event.cancelable) {
                event.preventDefault();
            }
        };

        document.addEventListener('touchmove', preventScroll, { passive: false });
        return () => {
            document.removeEventListener('touchmove', preventScroll);
        };
    }, [isActive]);
}
